import request from '@/utils/service'

export function list(data) {
  return request({
    url: '/rechargeOrderBatch/list',
    method: 'post',
    params: data
  })
}

export function detail(data) {
  return request({
    url: '/rechargeOrderBatch/detail',
    method: 'post',
    data
  })
}

export function add(data) {
  return request({
    url: '/rechargeOrderBatch/add',
    method: 'post',
    data
  })
}
export function edit(data) {
  console.log('data :>> ', data)
  return request({
    url: '/rechargeOrderBatch/update',
    method: 'post',
    data
  })
}
export function deleteApi(data) {
  return request({
    url: '/rechargeOrderBatch/delete',
    method: 'post',
    data
  })
}
